var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gs-app gm-list-detail"},[_c('div',{staticClass:"gm-list-detail__card"},[_c('p',[_vm._v(_vm._s(_vm.$t('frontend_groovemail_analytics_coming_soon')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }